export default "__VITE_ASSET__C8Iu8GSo__"